import { Component } from "react";
import AtomicSpinner from "atomic-spinner";
import { BsSearch } from "react-icons/bs";
import {
  FaRegCopyright,
  FaLinkedin,
  FaFacebookF,
  FaGithub,
} from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import Header from "../Header";
import VideoPlayer from "../Videoplayer";
import "./index.css";

const apiStatusConstants = {
  initial: "INITIAL",
  inProgress: "INPROGRESS",
  success: "SUCCESS",
  failure: "FAILURE",
};

class Home extends Component {
  state = {
    skuUrlList: [],
    kuUrlList: [],
    apiStatus: apiStatusConstants.inProgress,
  };

  componentDidMount() {
    this.getSKU();
    this.getKU();
  }

  getSKU = async () => {
    const response = await fetch(
      "https://myresultstelugu-backend.onrender.com/sku"
    );
    const data = await response.json();
    if (response.ok) {
      this.setState({
        skuUrlList: data.reverse(),
        apiStatus: apiStatusConstants.success,
      });
    } else {
      console.log("Something error happened");
      this.setState({ apiStatus: apiStatusConstants.failure });
    }
  };

  getKU = async () => {
    const response = await fetch(
      "https://myresultstelugu-backend.onrender.com/ku"
    );
    const data = await response.json();
    if (response.ok) {
      this.setState({ kuUrlList: data.reverse() });
    } else {
      console.log("Something error happened");
    }
  };

  renderContentContainer = () => {
    const { skuUrlList, kuUrlList } = this.state;
    return (
      <div className="home-content-container">
        <div className="left-tab-container">
          <div className="left-tab-content">
            <p>Semester II</p>
            <p>Semester V</p>
          </div>
        </div>
        <div className="right-tab-container">
          <div className="search-input-container-sm">
            <input type="text" className="search-input-sm" />
            <div className="search-icon-box-sm">
              <BsSearch />
            </div>
          </div>
          <h1 className="sku-heading">Sri Krishnadevaraya University</h1>
          <ul className="sku-container">
            {skuUrlList.map((eachItem) => {
              const { name, url } = eachItem;

              return (
                <li className="list-urls">
                  <a
                    className="anchor-url"
                    href={url}
                    rel="noreferrer"
                    target="_blank"
                  >
                    {name}
                  </a>
                </li>
              );
            })}
          </ul>
          <h1 className="sku-heading">Krishna University</h1>
          <ul className="sku-container">
            {kuUrlList.map((eachItem) => {
              const { name, url } = eachItem;

              return (
                <li className="list-urls">
                  <a
                    className="anchor-url"
                    href={url}
                    rel="noreferrer"
                    target="_blank"
                  >
                    {name}
                  </a>
                </li>
              );
            })}
          </ul>
          <VideoPlayer />
        </div>
      </div>
    );
  };

  renderFooterSection = () => {
    return (
      <div className="footer-section">
        <div className="footer-inner-container">
          <div className="bars-list-container">
            <p>Privacy Policy</p>
            <p>Terms of Service</p>
            <p>Support</p>
            <p>Copyright Policy</p>
          </div>
          <div className="social-media-container">
            <p className="follow-us-text">Follow Us</p>
            <div className="social-media-logo-section">
              <FaLinkedin />
              <FaFacebookF />
              <FaSquareXTwitter />
              <FaGithub />
            </div>
          </div>
        </div>
        <p className="rights-text">
          <FaRegCopyright /> Copyright 2024, QPT. All Rights Reserved.
          <p>PS Shajahan</p>
        </p>
      </div>
    );
  };

  renderFailureView = () => (
    <div className="failure-container">
      <img
        src="https://assets.ccbp.in/frontend/react-js/failure-img.png"
        alt="failure view"
        className="failure-view"
      />
      <h1 className="failure-heading">Oops! Something Went Wrong</h1>
      <p className="failure-desc">
        we cannot seem to find the page you are looking for
      </p>
      <button
        type="button"
        data-testid="button"
        className="jobs-failure-button"
        onClick={this.getJobDetails}
      >
        Retry
      </button>
    </div>
  );

  renderLoadingView = () => (
    <div className="profile-loader-container" data-testid="loader">
      <AtomicSpinner />
    </div>
  );

  renderResultsDetailsList = () => {
    const { apiStatus } = this.state;

    switch (apiStatus) {
      case apiStatusConstants.success:
        return this.renderContentContainer();
      case apiStatusConstants.failure:
        return this.renderFailureView();
      case apiStatusConstants.inProgress:
        return this.renderLoadingView();
      default:
        return null;
    }
  };

  render() {
    return (
      <div className="app-container">
        <Header />
        {this.renderResultsDetailsList()}
        <hr />
        {this.renderFooterSection()}
      </div>
    );
  }
}
export default Home;
